/**
 * Created by mnaughton on 10/16/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
export default BaseFieldView.extend({
  tagName: "span",

  template: function (options) {
    return _.escape(options.value) || "";
  },

  getControlValue: function () {
    return this.$el.html();
  },

  setControlValue: function (value) {
    this.$el.html(_.escape(value));
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/RawView.js
// module id = 848
// module chunks = 1